export default __webpack_public_path__ + "images/12afdd4fb94032b2977ec58f6d82af54.svg";